import { isObservableArray } from '@poa/state';

export function getValue(value, isDecimal) {
  const transformedValue = isObservableArray(value) ? value.join('') : value;
  const isNumber = typeof transformedValue === 'number';

  if (!isNumber) {
    return transformedValue;
  }

  if (isDecimal) {
    return Math.round(transformedValue * 100) / 100;
  }

  return transformedValue.toString().split('.')[0];
}

export function isObservableArraysOrStringsEqual(value1, value2) {
  if (isObservableArray(value1) && isObservableArray(value2)) {
    return value1.join('') === value2.join('');
  }

  return value1 === value2;
}

export function getValueFromRowByHeader(row, header) {
  let value;

  Object.keys(row).forEach(sectionId => {
    const sectionData = row[sectionId];

    if (!sectionData) {
      return;
    }

    // since we have status: "active" key here
    if (typeof sectionData === 'object') {
      Object.keys(sectionData).forEach(headerId => {
        if (headerId === header) {
          value = sectionData[headerId].value;
        }
      });
    }
  });

  return value;
}

export function findAggregationTypeByHeaderId(thead, headerId) {
  let result;

  Object.keys(thead).forEach(sectionId => {
    const header = thead[sectionId].find(header => header.name === headerId);
    if (header) {
      result = header.aggregation_type;
    }
  });

  return result || 'none';
}

export function findIsFilterOnServerSideHeaderId(thead, headerId) {
  let result;

  Object.keys(thead).forEach(sectionId => {
    const header = thead[sectionId].find(header => header.name === headerId);
    if (header) {
      result = header.filter;
    }
  });

  return result || false;
}

export function calculateSumByHeaderId(tbody, headerId) {
  let result = 0;

  tbody.forEach(row => {
    Object.keys(row).forEach(sectionId => {
      const cellData = row[sectionId][headerId];

      if (cellData) {
        const value = cellData.value.toString();

        if (value.includes('.')) {
          result += parseFloat(value);
        } else {
          const int = parseInt(value, 10);

          if (!isNaN(int)) {
            result += int;
          }
        }
      }
    });
  });

  return result;
}
